module.exports = __webpack_public_path__ + "static/media/ImgKOR.992e4259.svg";